export class Category {

    constructor(
        public label: string,
        public description: string,) {

        
    }
}